export const enableLogin = () => {
    return{
        type: 'SIGN_IN'
    }
}

export const educationActive = () => {
    return{
        type: 'EDU_ON'
    }
}

export const educationInactive = () => {
    return{
        type: 'EDU_OFF'
    }
}

export const skillsActive = () => {
    return{
        type: 'SKILLS_ON'
    }
}

export const skillsInactive = () => {
    return{
        type: 'SKILLS_OFF'
    }
}

export const profileActive = () => {
    return{
        type: 'PROF_ON'
    }
}

export const profileInactive = () => {
    return{
        type: 'PROF_OFF'
    }
}